import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import HeroManager from "@/pages/admin/HeroManager";
import AboutManager from "@/pages/admin/AboutManager";
import ServicesManager from "@/pages/admin/ServicesManager";
import ProductsManager from "@/pages/admin/ProductsManager";
import PackagesManager from "@/pages/admin/PackagesManager";
import PortfolioManager from "@/pages/admin/PortfolioManager";
import ProcessManager from "@/pages/admin/ProcessManager";
import TestimonialsManager from "@/pages/admin/TestimonialsManager";
import ContactsManager from "@/pages/admin/ContactsManager";
import PurchasesManager from "@/pages/admin/PurchasesManager";
import SettingsManager from "@/pages/admin/SettingsManager";
import StripeManager from "@/pages/admin/StripeManager";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="hero" element={<HeroManager />} />
            <Route path="about" element={<AboutManager />} />
            <Route path="services" element={<ServicesManager />} />
            <Route path="products" element={<ProductsManager />} />
            <Route path="packages" element={<PackagesManager />} />
            <Route path="portfolio" element={<PortfolioManager />} />
            <Route path="process" element={<ProcessManager />} />
            <Route path="testimonials" element={<TestimonialsManager />} />
            <Route path="contacts" element={<ContactsManager />} />
            <Route path="purchases" element={<PurchasesManager />} />
            <Route path="stripe" element={<StripeManager />} />
            <Route path="settings" element={<SettingsManager />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
